export default __webpack_public_path__ + "static/media/FoooterLogo.6d5a7be4.svg";